function AboutPage() {
    return (
        <div className="hero-body">
            <div className="container">
                <h1 className="title is-2">À propos</h1>
                <div className="content">
                    <p>
                        Halte-là, voyageur !
                    </p>
                    <p>
                        Ce que tu vois ici, c’est l’ouvrage d’un passionné, forgé à la sueur du front et au coin du feu. Ce site n’a pas
                        été bâti pour remplir des coffres d’or, mais pour garder trace de bandes dessinées déjà acquises… et pour ceux
                        qui voudraient en faire de même sans se perdre dans leurs parchemins.
                    </p>
                    <p>
                        Ne va pas croire qu’il s’agit d’une œuvre officielle : aucun seigneur, éditeur ou maître des lieux n’a apposé son
                        sceau ici. Ce projet est indépendant, libre comme l’air des montagnes.
                    </p>
                    <p>
                        Les mondes, les héros et les légendes auxquels il fait écho appartiennent à leurs véritables créateurs, et il en
                        sera toujours ainsi. Moi, je ne fais que tenir mes comptes et lever ma chope à leur gloire.
                    </p>
                    <p>
                        Alors profite, mais n’oublie pas : tu es ici dans une œuvre de fan, taillée avec respect… et un sacré caractère.
                    </p>
                    <p>
                        <i>
                            Ce projet est totalement indépendant et n’est en aucun cas affilié, soutenu ou approuvé par les ayants droit
                            officiels des œuvres originales. Tous les droits relatifs à cet univers, ses personnages et ses contenus
                            appartiennent à leurs créateurs et éditeurs respectifs.
                        </i>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default AboutPage;
